import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Timelog from '../components/Organisms/TimelogDetails';
import TimelogSummary from '../components/Organisms/TimelogSummary';
import WorkItems from '../components/Organisms/WorkItems';
import Projects from '../components/Organisms/Projects'
import Login from '../components/Organisms/Login';
import Reports from '../components/Organisms/Reports';
import Movetimelog from '../components/Organisms/Movetimelog';
import AccessPage from '../components/Organisms/AccessPage';
import Calendar from '../components/Organisms/Calendar'
import AccessControl from "../components/Organisms/AccessControlList";
import AccessPageList from "../components/Organisms/AccessPageList";
import TimelogSetting from "../components/Organisms/Settings";
function RequireAuth({ children }) {
    const authed = localStorage.getItem('access_token');
    if (authed) {
        return children
    } else {
        return <Login />
    }
}



const AppRouter = () => {
    return <BrowserRouter>
        <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/timelogsummary" element={<RequireAuth><TimelogSummary /></RequireAuth >} />
            <Route exact path="/timelog/:project_id/:workitem_id" element={<RequireAuth><Timelog /></RequireAuth >} />
            <Route exact path="/workitems/:project_id" element={<RequireAuth><WorkItems /></RequireAuth >} />
            <Route exact path="/projects" element={<RequireAuth><Projects /></RequireAuth >} />
            <Route exact path="/reports" element={<RequireAuth><Reports /></RequireAuth >} />
            <Route exact path="/calendar" element={<RequireAuth><Calendar /></RequireAuth >} />
            <Route exact path="/movetimelog" element={<RequireAuth><Movetimelog /></RequireAuth >} />
            <Route exact path="/access-control" element={<RequireAuth><AccessControl /></RequireAuth >} />
            <Route exact path="/access-page-list" element={<RequireAuth><AccessPageList /></RequireAuth >} />
            <Route exact path="/timelogsetting" element={<RequireAuth><TimelogSetting /></RequireAuth >} />
        </Routes>
    </BrowserRouter>
}


export default AppRouter;
